import { ThemeProvider, ThemeStyles } from "@bonusx-global/bx-design-system";
import StyledEngineProvider from "@mui/material/StyledEngineProvider";
import { OpenFeatureProvider } from "@openfeature/react-sdk";
import { Provider as JotaiProvider } from "jotai";
import React from "react";
import { Provider } from "react-redux";
import { ChatbotProvider } from "./components/Chatbot/contexts/chatbot-provider";
import { InitializeApp } from "./components/initialize-app/initialize-app";
import SuspenseWrapper from "./components/SuspenseWrapper";
import { WindowBeforeUnload } from "./components/WindowBeforeUnload";
import { ErrorHttpProvider } from "./contexts/ErrorHttpContext/providers/ErrorHttpProvider";
import { ClientConstantsProvider } from "./services/client-constants/provider/client-constants-provider";
import store from "./store";
import citizenTheme from "./styles/citizenTheme";

interface ProvideEssentialsProps {
  readonly children: React.ReactNode;
}

export function ProvideEssentials({ children }: ProvideEssentialsProps) {
  return (
    <Provider store={store}>
      <JotaiProvider>
        <SuspenseWrapper>
          <OpenFeatureProvider suspend={true}>
            <ClientConstantsProvider>
              <ErrorHttpProvider>
                <ChatbotProvider>
                  <InitializeApp />
                  <WindowBeforeUnload />
                  <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={citizenTheme}>
                      <ThemeStyles />
                      {children}
                    </ThemeProvider>
                  </StyledEngineProvider>
                </ChatbotProvider>
              </ErrorHttpProvider>
            </ClientConstantsProvider>
          </OpenFeatureProvider>
        </SuspenseWrapper>
      </JotaiProvider>
    </Provider>
  );
}
